<template>
  <v-snackbar v-model="snackbar" :timeout="timeout" vertical bottom left>
    <span class="overline primary--text">Cotización actual</span>
    <template v-for="(item, i)  in getActualCotizationPartidas">
      <v-row :key="`item-${i}`" class="overline" no-gutters>
        <v-col>{{item.ProClave}}</v-col>
        <v-col>{{item.CantidadPiezas}}</v-col>
      </v-row>
    </template>
  </v-snackbar>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        snackbar: true,
        headers: [
          {
            text: "Producto",
            value: "ProClave",
            align: "left"
          },
          {
            text: "Cant",
            align: "left",
            value: "CantidadPiezas"
          }
        ],
        timeout: 0,
        text:
          "Hello, I'm a snackbar Hello, I'm a snackbarHello, I'm a snackbarHello, I'm a snackbarHello, I'm a snackbarHello, I'm a snackbarHello, I'm a snackbarHello, I'm a snackbarHello, I'm a snackbar"
      };
    },
    computed: mapGetters(["getActualCotizationPartidas"])
  };
</script>